import { EstadoDocumentoItem } from "../../common/enumModel";
import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";

export class SolicitudDocumentoModel implements ISolicitudDocumentoModel {
    idDocumento: number;
    idEstado: EstadoDocumentoItem;

    constructor(){
        this.idDocumento = 0;
        this.idEstado = EstadoDocumentoItem.PENDIENTE;
    }
}